import React, { useEffect, useRef, useState } from "react";
import MessageTemplate from "../../MessageTemplate/MessageTemplate";
import * as S from "../styles";
import ReplySources from "../ReplySources/ReplySources";
import { FileAttachment } from "../FileAttachment";
import { VideosAttachment } from "../VideosAttachment";
import { ImageAttachment } from "../ImageAttachment";
import { AudioAttachment } from "../AudioAttachment";
import { SendOutlined } from "@material-ui/icons";
import { useContactsState } from "modules/app/contexts";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import localforage from "localforage";

export default function SendMessage({
  handleSubmit,
  handlePasteImg,
  answerMessage,
  setAnswerMessage,
  isSending,
  setIsSending,
  replySources,
  setReplySources,
}) {
  const { currentContact } = useContactsState();
  const { id } = useParams();
  const focusInput = useRef();
  const { t } = useTranslation(["Chat", "Customer"]);

  const [text, setText] = useState("");
  const [cursorPosition, setCursorPosition] = useState(0);
  const [emojiPicker, setEmojiPicker] = useState(false);
  const [uploadMenu, setUploadMenu] = useState(false);

  function handleTextInput(e) {
    setText(e.target.value);
  }

  function handleMessageTemplate(text) {
    setTimeout(() => {
      const element = focusInput?.current;
      element?.focus();

      setText(text);

      element.scrollTop = element?.scrollHeight;
    }, 10);
  }

  function handleKeyPress(event) {
    if (!event.shiftKey && !event.ctrlKey && event.key === "Enter") {
      handleSubmitMessage(event);
    }
  }

  function handleSubmitMessage(event) {
    event.preventDefault();
    setEmojiPicker(false);
    setUploadMenu(false);
    handleSubmit(text);
    setText("");
  }

  function handleSelectEmoji(event, emojiObject) {
    const ref = focusInput.current;
    ref.focus();
    const start = text.substring(0, ref.selectionStart);
    const end = text.substring(ref.selectionStart);
    const message = start + emojiObject.emoji + end;
    setText(message);
    setCursorPosition(start.length + emojiObject.emoji.length);
  }

  function handleOpenEmojiPicker() {
    setEmojiPicker((prevState) => !prevState);
  }

  function handleUploadMenu() {
    setUploadMenu((prevState) => !prevState);
  }

  useEffect(() => {
    async function loadCachedMessageById() {
      const messageText = await localforage.getItem(`message-${id}`);
      setText(messageText || "");
    }

    loadCachedMessageById();
  }, [id]);

  useEffect(() => {
    if (text === "") {
      localforage.removeItem(`message-${id}`);
    } else {
      localforage.setItem(`message-${id}`, text);
    }
  }, [text]);

  useEffect(() => {
    if (currentContact?.reply_sources) {
      setReplySources(currentContact.reply_sources);
      setIsSending(false);
    }
  }, [currentContact]);

  useEffect(() => {
    focusInput?.current?.focus();
  }, [currentContact.id]);

  useEffect(() => {
    focusInput.current.selectionEnd = cursorPosition;
  }, [cursorPosition]);

  return (
    <S.Form onSubmit={handleSubmitMessage}>
      {replySources && (
        <ReplySources
          replySources={replySources}
          setReplySources={setReplySources}
        />
      )}

      <S.SendMessageContainer>
        <S.SendMessageField
          inputRef={focusInput}
          onChange={(e) => handleTextInput(e)}
          onPaste={(e) => handlePasteImg(e)}
          value={text}
          autoFocus
          rowsMax="5"
          multiline
          InputProps={{
            disableUnderline: true,
            placeholder: t("labels.message"),
          }}
          InputLabelProps={{
            shrink: false,
          }}
          onKeyPress={(e) => handleKeyPress(e)}
          fullWidth
        />

        {!text && <MessageTemplate setText={handleMessageTemplate} />}
      </S.SendMessageContainer>

      <S.EmojiPickerContainer>
        {emojiPicker && (
          <S.EmojiPicker
            onEmojiClick={(e, emoji) => handleSelectEmoji(e, emoji)}
          />
        )}
        <S.EmojiPickerButton onClick={() => handleOpenEmojiPicker()} />
      </S.EmojiPickerContainer>

      {!text ? (
        <>
          {currentContact?.contact?.phone && (
            <>
              <S.UploadMenu isOpen={uploadMenu}>
                <FileAttachment
                  setAnswerMessage={setAnswerMessage}
                  answerMessage={answerMessage}
                  replySources={replySources}
                />
                {(replySources?.email?.checked ||
                  replySources?.whatsapp?.checked) && (
                  <VideosAttachment
                    setAnswerMessage={setAnswerMessage}
                    answerMessage={answerMessage}
                    replySources={replySources}
                  />
                )}
                <ImageAttachment
                  setAnswerMessage={setAnswerMessage}
                  answerMessage={answerMessage}
                  replySources={replySources}
                />
              </S.UploadMenu>

              <S.UploadButton onClick={handleUploadMenu}>
                <S.UploadIcon />
              </S.UploadButton>

              <AudioAttachment
                setAnswerMessage={setAnswerMessage}
                answerMessage={answerMessage}
                replySources={replySources}
              />
            </>
          )}
        </>
      ) : (
        <S.SendButton type="submit" disabled={isSending}>
          <SendOutlined />
        </S.SendButton>
      )}
    </S.Form>
  );
}
